import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../api/axiosInstance";
// Async Thunk for fetching notification types
export const fetchNotificationTypes = createAsyncThunk(
  "lookup/fetchNotificationTypes",
  async ({ subCategoryId,language }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/api/Admin/GetNotificationTypes",
        {
          subCategoryFk: subCategoryId,
        },
        {
          headers: {
            "accept": "text/plain",
            "Content-Type": "application/json-patch+json",
            "lang": language === "English" ? "2" : "1",
          },
        }
      );
      
      // Parsing the JSON string in the response message
      const notificationTypes = JSON.parse(response.data.message).Data;

      return { subCategoryId, data: notificationTypes };
    } catch (error) {
      console.error("Error fetching notification types:", error);
      return rejectWithValue(error.response?.data || "Error fetching notification types");
    }
  }
);

const notificationTypeSlice = createSlice({
  name: "notificationTypes",
  initialState: {
    notificationTypes: {}, // Stores notification types by subCategoryId
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotificationTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNotificationTypes.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.notificationTypes[payload.subCategoryId] = payload.data;
      })
      .addCase(fetchNotificationTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default notificationTypeSlice.reducer;
